import { render, staticRenderFns } from "./AssessmentImport.vue?vue&type=template&id=1c30f561&scoped=true&"
import script from "./AssessmentImport.vue?vue&type=script&lang=js&"
export * from "./AssessmentImport.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentImport.vue?vue&type=style&index=0&id=1c30f561&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c30f561",
  null
  
)

export default component.exports